import React from 'react';
import { cn } from './cn';

export const IconButton = React.forwardRef<HTMLButtonElement, React.ButtonHTMLAttributes<HTMLButtonElement>>(
  function IconButton({ className, type = 'button', ...props }, ref) {
    return (
      <button
        ref={ref}
        type={type}
        className={cn(
          'relative grid h-10 w-10 shrink-0 place-items-center rounded-ds-6 border-0 bg-transparent text-ds-700 transition-colors hover:bg-ds-subtle disabled:pointer-events-none disabled:opacity-50',
          className,
        )}
        {...props}
      />
    );
  },
);
